module.exports = __webpack_public_path__ + "img/rabbit.99357ef0.png";